import React, { useCallback } from 'react';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ModalTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ModalTitle';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import ModalGroupBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalGroupBtn';
import * as S from './style';
import Button from '../../../atoms/Button';

interface IProps {
  onClose?: () => void;
  value: {
    constText: string;
    suffixText: string;
    snsItems: [];
    isDesktop: boolean;
    isIPhoneXApp: boolean;
  };
}

const ShareModal = ({ onClose, value }: IProps) => {
  const { isDesktop, isIPhoneXApp, constText, suffixText, snsItems } = value;

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.ShareModal>
      {isDesktop ? (
        <ModalCloseBtn onClick={handleClose} />
      ) : (
        <ModalEdgeCloseBtn onClick={handleClose} />
      )}
      <ModalTitle title="공유하기" />
      <div className="content">
        {constText && (
          <Text className="cont-text">
            <span className="ellipsis-text">{constText}</span>
            {suffixText && <span className="fixed-text">{suffixText}</span>}
          </Text>
        )}
        {snsItems.length > 0 && <div className="sns-list">{snsItems}</div>}
      </div>
    </S.ShareModal>
  );
};

export default ShareModal;
